const subtitleExtensions = new Set<string>(["srt", "ssa", "txt", "scc", "vtt"]);

export const isSubtitlesFile = (extension: string): boolean => {
    return subtitleExtensions.has(extension.toLowerCase());
};
